import config from './configuration'
import ConstantsList from '../common/SCConstants';

// this block needed to get the login Token and Login user _id 
let localData = localStorage.getItem('userData');
let userData={}
if(localData){
    userData = JSON.parse(localData);
}

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

/* Service Function starts here */

//POST - getMenuOnUserRole
async function getMenuOnUserRole(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/getMenu";
    return callPOST(api_url, param);
}

// get info from the configuration.js file
async function getConfig() {
    return config;
}

//POST - Get User Login Details using _id
async function getLoginUserData() { // This method calling from Redux
    let api_url= config.BASE_URL + 'api/getUserDetails';
    let param = {"_id" : userData.data._id}
    return callPOST(api_url, param);
}

// API Error Handling
async function handleResponseError(response) {
    throw new Error("HTTP error, status = " + response.status);
}

// API Error Handling
async function handleError(error) {
    console.log(error.message);
}

async function callFileDownload(api_url, param) {
  if (!param) {
    param = {};
  }
  param.timeZone = userTimezone;

  return await fetch(api_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + userData.token,
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
        throw new Error("Network response was not ok");
      }
      return response.blob(); // Important: handle as blob for file
    })
    .catch((error) => {
      handleError(error);
      throw error;
    });
}

// Common GET Method 
async function callGET(api_url) {
    return fetch(api_url,{
                method:'GET',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json",
                    "Authorization": 'Bearer '+ userData.token
                }
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                if(items.responseCode !== 401){
                    // console.log(">> GET Service Call",items);
                    return items;
                }else{
                    console.log(">> Session Timeout",items);
                    localStorage.setItem('token',''); 
                    localStorage.setItem('userData','');
                    window.location = ConstantsList.LOGIN;
                }            
            }).catch(error => {
                console.log(">> e", error);
                handleError(error);
            });
}

// Common POST Method
async function callPOST(api_url,param) {
    // console.log(">> check URL", api_url);
    if(!param){
        param = {}
    }
    param.timeZone = userTimezone;
    return await fetch(api_url,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json",
                    "Authorization": 'Bearer '+ userData.token
                },
                body:JSON.stringify(param)
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                // console.log(">> Service Login Data",items);
                if(items.responseCode !== 401){
                    // console.log(">> POST Service Call",items);
                    return items;
                }else{
                    console.log(">> Session Timeout",items);
                    localStorage.setItem('token',''); 
                    localStorage.setItem('userData','');
                    window.location = ConstantsList.LOGIN;
                }     
               
            }).catch(error => {
                handleError(error);
            });
}

// Common POST Method for Upload
async function callPOSTUpload(api_url,param) {
    // console.log(">>callPOSTUpload param ", param);
    return await fetch(api_url,{
                method:'POST',
                headers:{
                    // 'Content-Type': 'multipart/form-data',
                    "Authorization": 'Bearer '+ userData.token,
                },
                body:param
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                // console.log(">> Service Login Data",items);
                if(items.responseCode !== 401){
                    // console.log(">> POST Service Call",items);
                    return items;
                }else{
                    console.log(">> Session Timeout",items);
                    localStorage.setItem('token',''); 
                    localStorage.setItem('userData','');
                    window.location = ConstantsList.LOGIN;
                }     
               
            }).catch(error => {
                handleError(error);
            });
}

//POST - Upload files
async function uploadFiles(param) {
    let api_url= config.BASE_URL + 'api/uploadFiles';
    return callPOSTUpload(api_url,param);
}
//POST - Upload Article
async function uploadArticleFile(param) {
    let api_url= config.BASE_URL + 'api/uploadArticleFile';
    return callPOSTUpload(api_url,param);
}
//POST - getUploadedFiles files
async function getUploadedFiles(param) {
    let api_url= config.BASE_URL + 'api/getUploadedFiles';
    return callPOST(api_url,param);
}

/* ---------------------------- Dashboard --------------------------------*/

//dashboard - supplier // "Yearly", "Monthly", "Custom"
async function dashboard(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/dashboard";
    return callPOST(api_url, param);
}

//Generate Chart Query
async function generateChartQuery(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/generateChartQuery";
    return callPOST(api_url, param);
}


/* ---------------------------- AP Automation APP --------------------------------*/

// AP List 
async function generatePlmQuery(param) {// This method calling from Redux
    let api_url = config.BASE_URL + "customer/api/generateCustomerQuery";
    return callPOST(api_url, param);
}

/* ---------------------------- Workflow --------------------------------*/

//POST - getWorkflowInboxCards
async function getWorkflowInboxCards(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/workflowInboxCards";
  return callPOST(api_url, param);
}

//POST - getworkflowInboxList
async function getworkflowInboxList(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/workflowInboxList";
  return callPOST(api_url, param);
}

//POST - workflowApproveReject
async function workflowApproveReject(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/actionOnCustomerWorkflowEvent";
  return callPOST(api_url, param);
}

//workflowActionAPI
async function workflowActionAPI(URL, param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + URL;
  return callPOST(api_url, param);
}

//------------------------construnction----------------------------------------------/

async function addQuotationOrJob(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/addQuotationOrJob";
  return callPOST(api_url, param);
}

async function generateCustomerQueryHb(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/generateCustomerQuery";
  return callPOST(api_url, param);
}

async function updateQuotationOrJob(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/updateQuotationOrJob";
  return callPOST(api_url, param);
}

async function getMasterData(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getMasterData";
  return callPOST(api_url, param);
}

async function deleteEstimation(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/deleteEstimation";
  return callPOST(api_url, param);
}

async function updateEstimation(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/updateEstimation";
  return callPOST(api_url, param);
}

async function assignEstimation(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/assignEstimation";
  return callPOST(api_url, param);
}

async function addEstimation(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/addEstimation";
  return callPOST(api_url, param);
}

async function convertQuotationToJob(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/convertQuotationToJob";
  return callPOST(api_url, param);
}

async function reviseEstimation(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/reviseEstimation";
  return callPOST(api_url, param);
}

async function downloadExcel(param) {
  let api_url = config.BASE_URL + "customer-v1/api/downloadExcel";
  return callFileDownload(api_url, param);
}


async function reviseQuotationOrJob(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/reviseQuotationOrJob";
  return callPOST(api_url, param);
}

async function addMaterial(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/addMaterial";
  return callPOST(api_url, param);
}

async function updateMaterialHb(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/updateMaterial";
  return callPOST(api_url, param);
}

async function deleteMaterialHb(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/deleteMaterial";
  return callPOST(api_url, param);
}

async function generateCustomerQuery(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/generateCustomerQuery";
  return callPOST(api_url, param);
}

async function ChartCountCard(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/ChartCountCard";
  return callPOST(api_url, param);
}

async function dashboardHb(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/dashboard";
  return callPOST(api_url, param);
}

const func = {    
    handleResponseError,
    handleError,
    callGET,
    callPOST,
    callPOSTUpload, 

    getMenuOnUserRole,
    getConfig,
    getLoginUserData,
    uploadFiles,
    getUploadedFiles,    
    
    generateChartQuery,
    dashboard,

    uploadArticleFile,
    generatePlmQuery,
    
    getWorkflowInboxCards,
    getworkflowInboxList,
    workflowApproveReject,
    workflowActionAPI,
    addQuotationOrJob,
    generateCustomerQueryHb,
    updateQuotationOrJob,
    getMasterData,
    deleteEstimation,
    updateEstimation,
    assignEstimation,
    addEstimation,
    convertQuotationToJob,
    reviseEstimation,
    downloadExcel,
    reviseQuotationOrJob,
    deleteMaterialHb,
    addMaterial,
    updateMaterialHb,
    generateCustomerQuery,
    ChartCountCard,
    dashboardHb
};

export default func;